export default {
	current_page: 1,
	data: [],
	first_page_url: '',
	from: 1,
	last_page: 1,
	last_page_url: '',
	next_page_url: null,
	path: '',
	per_page: 15,
	prev_page_url: null,
	to: 1,
	total: 0
}
